import { useSelector } from 'react-redux';

import { brandSelector } from 'store/brandState/brandState';

export const useBrand = () => {
  const brand = useSelector(brandSelector);

  return brand;
};
